import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v1/';
const API_URL_V3 =  process.env.API_URL + '/api/v3';

class TujuanPembukaanRek {
  indexV3() {
    return Axios.get(API_URL_V3 + '/data/account-opening-purposes');
  }
  index() {
    return Axios.get(API_URL + 'tujuanpembukaanrekening-list');
  }

  show(tujuanpembukaanrekening) {
    return Axios.get(API_URL + `tujuanpembukaanrekening/${tujuanpembukaanrekening}`);
  }
}

export default new TujuanPembukaanRek();



// WEBPACK FOOTER //
// ./src/api/tujuanpembukaanrekening.js